import { types } from '.';
import { Job } from 'packages/v3/jobs/Job';
export var actions = {
    startJobWizard: function (_a) {
        var commit = _a.commit;
        commit(types.SET_JOB, new Job());
        commit(types.SET_ATTACHED_ATTRIBUTES, []);
        commit(types.SET_START_TIME, performance.now());
    },
};
